<a class="notification-link" (click)="downloadFile()">{{
  'Dashboard::ClickHereToDownloadAgentObjectionReport' | abpLocalization
}}</a>